(ns iris.posts.views.filter-top-bar
  (:require
   [cemerick.url :as cemerick.url]
   [re-frame.core :as re-frame]
   [iris.subs :as subs]
   [iris.posts.common :refer [route-prefix]]
   [iris.globals :as globals]
  ;;  [herb.core :refer [<class <id]]
   [iris.styles.posts :as $posts]))

;; TODO: could be refactored more - btns reused

(defn filter-top-bar-posts-logs [section]
  (let [{:keys [posts-href logs-href]} @(re-frame/subscribe [::subs/mirror-hrefs])]
    [:div.btn-group.btn-group-sm
     {:role "group"}
     [:a.btn {:href posts-href
              :class (if (= section "posts") "btn btn-primary" "btn btn-default")} "Posts"]
     [:a.btn {:href logs-href
              :class (if (= section "logs") "btn btn-primary" "btn btn-default")} "Logs"]]))



(defn remove-btn [qp k]
  (when (some? (k qp))
    [:a.btn.btn-default
     {:title "remove filter"
      :href (str "?" (cemerick.url/map->query (dissoc qp k :bm)))}
     [:i.glyphicon.glyphicon-remove-circle.text-danger]]))



(defn filter-top-bar-ws [qp options websites]
  [:div.btn-group.btn-group-sm
   {:role "group"
    :style {:margin "5px"}}
   (for [ws websites]
     [:a.btn {:key (str ws "-btn")
              :href (if-not (false? (:ws options))
                      (str  "?" (cemerick.url/map->query (-> qp
                                                             (dissoc :bm)
                                                             (conj {:ws ws}))))
                      (let [route "/posts"]
                        (str route "?" (cemerick.url/map->query {:ws ws}))))
              :class (if (= (:ws qp) ws)
                       (if-not (false? (:ws options)) "btn-primary" "btn-gray")
                       "btn-default")
              :title (str "Filter website: " ws)} ws])])



(defn filter-top-bar-level [qp]
  [:div.btn-group.btn-group-sm
   {:role "group"
    :style {:margin "5px"}}
   [:a.btn {:href (str "?" (cemerick.url/map->query
                            ;; (conj qp {:level 1})
                            (-> qp
                                ;; (dissoc :page)
                                (dissoc :bm)
                                (conj {:level 1}))))
            :class (if (= (:level qp) "1") "btn-primary" "btn-default")
            :title "Filter OPs"} "OPs"]
   [:a.btn {:href (str "?" (cemerick.url/map->query
                            ;; (conj qp {:level 2})
                            (-> qp
                                ;; (dissoc :page)
                                (dissoc :bm)
                                (conj {:level 2}))))
            :class (if (= (:level qp) "2") "btn-primary" "btn-default")
            :title "Filter replies"} "replies"]
   [remove-btn qp :level]])

(defn filter-top-bar-status [qp]
  [:div.btn-group.btn-group-sm
   {:role "group"
    :style {:margin "5px"}}
   [:a.btn.btn-default
    {:href (str "?" (cemerick.url/map->query
                    ;;  (conj qp {:status "P"})
                     (-> qp
                        ;;  (dissoc :page)
                         (dissoc :bm)
                         (conj {:status "P"}))))
     :class (if (= (:status qp) "P") "btn-primary" "btn-default")
     :title "Filter status: Published"} "P"]
   [:a.btn.btn-default
    {:href (str "?" (cemerick.url/map->query
                    ;;  (conj qp {:status "Q"})
                     (-> qp
                        ;;  (dissoc :page)
                         (dissoc :bm)
                         (conj {:status "Q"}))))
     :class (if (= (:status qp) "Q") "btn-primary" "btn-default")
     :title "Filter status: Quarantined"} "Q"]
   [:a.btn.btn-default
    {:href (str "?" (cemerick.url/map->query
                    ;;  (conj qp {:status "R"})
                     (-> qp
                        ;;  (dissoc :page)
                         (dissoc :bm)
                         (conj {:status "R"}))))
     :class (if (= (:status qp) "R") "btn-primary" "btn-default")
     :title "Filter status: Removed"} "R"]
   [:a.btn.btn-default
    {:href (str "?" (cemerick.url/map->query
                    ;;  (conj qp {:status "T"})
                     (-> qp
                        ;;  (dissoc :page)
                         (dissoc :bm)
                         (conj {:status "T"}))))
     :class (if (= (:status qp) "T") "btn-primary" "btn-default")
     :title "Filter status: Thread removed"} "T"]
   [:a.btn.btn-default
    {:href (str "?" (cemerick.url/map->query
                    ;;  (conj qp {:status "S"})
                     (-> qp
                        ;;  (dissoc :page)
                         (dissoc :bm)
                         (conj {:status "S"}))))
     :class (if (= (:status qp) "S") "btn-primary" "btn-default")
     :title "Filter status: Submitted"} "S"]
   [remove-btn qp :status]])

(defn filter-top-bar-flag [qp]
  [:div.btn-group.btn-group-sm
   {:role "group"
    :style {:margin "5px"}}
   [:a.btn.btn-default
    {:title "Filter flag: Level 1"
     :href (str "?" (cemerick.url/map->query
                    ;;  (conj qp {:flag 1})
                     (-> qp
                        ;;  (dissoc :page)
                         (dissoc :bm)
                         (conj {:flag 1}))))
     :class (if (= (:flag qp) "1") "btn-primary" "btn-default")}
    [:i.glyphicon.glyphicon-flag.text-success]]
   [:a.btn.btn-default
    {:title "Filter flag: Level 2"
     :href (str "?" (cemerick.url/map->query
                    ;;  (conj qp {:flag 2})
                     (-> qp
                        ;;  (dissoc :page)
                         (dissoc :bm)
                         (conj {:flag 2}))))
     :class (if (= (:flag qp) "2") "btn-primary" "btn-default")}
    [:i.glyphicon.glyphicon-flag.text-warning]]
   [:a.btn.btn-default
    {:title "Filter flag: Level 3"
     :href (str "?" (cemerick.url/map->query
                    ;;  (conj qp {:flag 3})
                     (-> qp
                        ;;  (dissoc :page)
                         (dissoc :bm)
                         (conj {:flag 3}))))
     :class (if (= (:flag qp) "3") "btn-primary" "btn-default")}
    [:i.glyphicon.glyphicon-flag.text-danger]]
   [:a.btn.btn-default
    {:title "Filter flag: Level 4"
     :href (str "?" (cemerick.url/map->query
                    ;;  (conj qp {:flag 4})
                     (-> qp
                        ;;  (dissoc :page)
                         (dissoc :bm)
                         (conj {:flag 4}))))
     :class (if (= (:flag qp) "4") "btn-primary" "btn-default")}
    [:i.glyphicon.glyphicon-flag.text-dark]]
   [:a.btn.btn-default
    {:title "Filter flag: Level 1 or 2"
     :href (str "?" (cemerick.url/map->query
                    ;;
                     (-> qp
                        ;;  (dissoc :page)
                         (dissoc :bm)
                         (conj {:flag "2-"}))))
     :class (if (= (:flag qp) "2-") "btn-primary" "btn-default")}
    [:i.glyphicon.glyphicon-flag.text-success]
    [:i.glyphicon.glyphicon-flag.text-warning]]
   [:a.btn.btn-default
    {:title "Filter flag: Level 3 or 4"
     :href (str "?" (cemerick.url/map->query
                    ;;  (conj qp {:flag "3+"})
                     (-> qp
                        ;;  (dissoc :page)
                         (dissoc :bm)
                         (conj {:flag "3+"}))))
     :class (if (= (:flag qp) "3+") "btn-primary" "btn-default")}
    [:i.glyphicon.glyphicon-flag.text-danger]
    [:i.glyphicon.glyphicon-flag.text-dark]]
   [:a.btn.btn-default
    {:title "Filter flag: Any flag level"
     :href (str "?" (cemerick.url/map->query
                    ;;  (conj qp {:flag "any"})
                     (-> qp
                        ;;  (dissoc :page)
                         (dissoc :bm)
                         (conj {:flag "any"}))))
     :class (if (= (:flag qp) "any") "btn-primary" "btn-default")}
    [:i.glyphicon.glyphicon-flag.text-success]
    [:i.glyphicon.glyphicon-flag.text-warning]
    [:i.glyphicon.glyphicon-flag.text-danger]
    [:i.glyphicon.glyphicon-flag.text-dark]]
   [remove-btn qp :flag]])

(defn filter-top-bar-staff [qp]
  [:div.btn-group.btn-group-sm
   {:role "group"
    :style {:margin "5px"}}
   [:a.btn.btn-default
    {:title "Filter staff posts only"
     :href (str "?" (cemerick.url/map->query
                    ;;  (conj qp {:staff "yes"})
                     (-> qp
                        ;;  (dissoc :page)
                         (dissoc :bm)
                         (conj {:staff "yes"}))))
     :class (if (= (:staff qp) "yes") "btn-primary" "btn-default")} "staff"]
   [:a.btn.btn-default
    {:title "Filter non-staff posts only"
     :href (str "?" (cemerick.url/map->query
                    ;;  (conj qp {:staff "no"})
                     (-> qp
                        ;;  (dissoc :page)
                         (dissoc :bm)
                         (conj {:staff "no"}))))
     :class (if (= (:staff qp) "no") "btn-primary" "btn-default")} "non-staff"]
   [remove-btn qp :staff]])


(defn filter-top-bar [qp options]
  [:div#filter-top-bar
   {:style {:text-align "center"}}
   [:div#filters.container-fluid
    [:span {:class
            ;; (<class $posts/filter-display-labels)
            $posts/$filter-display-labels} "\n\t\tFilters:\n\t\t\n\n"]
    [filter-top-bar-ws qp options (:websites @globals/jwt-payload)]
    ;; TODO: enable when the logs section is ready
    (when (not (false? (:level options)))
      [filter-top-bar-level qp])
    (when (not (false? (:status options)))
      [filter-top-bar-status qp])
    (when (not (false? (:flag options)))
      [filter-top-bar-flag qp])
    (when (not (false? (:staff options)))
      [filter-top-bar-staff qp])]])



